(() => {
  const root=document.querySelector('[data-audio-analyzer]'); if(!root)return;
  const dropzone=root.querySelector('[data-dropzone]'),input=root.querySelector('[data-file-input]'),progress=root.querySelector('[data-progress-detail]')?.closest('[data-progress]')||root.querySelector('[data-progress]'),detail=root.querySelector('[data-progress-detail]'),results=root.querySelector('[data-results]'),errorBox=root.querySelector('[data-error]'),fileName=root.querySelector('[data-file-name]'),bpmOut=root.querySelector('[data-bpm]'),keyOut=root.querySelector('[data-key]'),keyNoteOut=root.querySelector('[data-key-note]'),keyModeOut=root.querySelector('[data-key-mode]'),keyDial=root.querySelector('.mm-key-dial'),tempoStage=root.querySelector('.mm-tempo-stage'),camelotOut=root.querySelector('[data-camelot]'),relativeKeyOut=root.querySelector('[data-relative-key]'),relativeKeyWrap=root.querySelector('[data-relative-key-wrap]'),relativeLabel=root.querySelector('[data-relative-label]'),enharmonicKeyOut=root.querySelector('[data-enharmonic-key]'),keySpellingOut=root.querySelector('[data-key-spelling]'),keySpellingWrap=root.querySelector('[data-key-spelling-wrap]'),halfOut=root.querySelector('[data-half-bpm]'),doubleOut=root.querySelector('[data-double-bpm]'),halfBtn=root.querySelector('[data-use-half]'),doubleBtn=root.querySelector('[data-use-double]'),again=root.querySelector('[data-analyze-another]');
  const AudioCtx=window.AudioContext||window.webkitAudioContext; let ctx=null,currentTempo=0;
  const setState=s=>{dropzone.hidden=s!=='drop';progress.hidden=s!=='progress';results.hidden=s!=='results';errorBox.hidden=s!=='error';root.classList.toggle('is-processing',s==='progress');};
  progress.hidden=true;results.hidden=true;errorBox.hidden=true;dropzone.hidden=false;
  const showError=m=>{errorBox.textContent=m;setState('error');};
  const tick=()=>new Promise(r=>requestAnimationFrame(r));
  const decode=async file=>{if(!AudioCtx)throw new Error('Your browser does not support local audio analysis.');if(!ctx)ctx=new AudioCtx();return await ctx.decodeAudioData((await file.arrayBuffer()).slice(0));};
  let essentiaPromise=null;
  const getEssentia=async()=>{
    if(essentiaPromise)return essentiaPromise;
    essentiaPromise=(async()=>{
      if(typeof window.EssentiaWASM!=='function'||typeof window.Essentia!=='function'){
        throw new Error('The advanced BPM engine could not load. Please refresh and try again.');
      }
      const wasm=await window.EssentiaWASM();
      return new window.Essentia(wasm);
    })();
    return essentiaPromise;
  };
  const resample44100=async buffer=>{
    if(buffer.sampleRate===44100)return buffer;
    const OfflineCtx=window.OfflineAudioContext||window.webkitOfflineAudioContext;
    if(!OfflineCtx)throw new Error('This browser cannot prepare audio for BPM analysis.');
    const length=Math.ceil(buffer.duration*44100);
    const offline=new OfflineCtx(1,length,44100);
    const source=offline.createBufferSource();
    source.buffer=buffer;
    source.connect(offline.destination);
    source.start(0);
    return await offline.startRendering();
  };
  const monoFromBuffer=b=>{
    const len=b.length,out=new Float32Array(len),ch=Math.min(2,b.numberOfChannels);
    for(let c=0;c<ch;c++){
      const s=b.getChannelData(c);
      for(let i=0;i<len;i++)out[i]+=s[i]/ch;
    }
    return out;
  };
  const vectorArray=(essentia,v)=>{
    if(!v)return[];
    try{
      if(typeof essentia.vectorToArray==='function')return Array.from(essentia.vectorToArray(v)||[]);
      if(Array.isArray(v)||ArrayBuffer.isView(v))return Array.from(v);
    }catch(_){}
    return[];
  };
  const median=values=>{
    const a=values.filter(Number.isFinite).slice().sort((x,y)=>x-y);
    if(!a.length)return 0;
    const m=a.length>>1;
    return a.length%2?a[m]:(a[m-1]+a[m])/2;
  };
  const robustBeatGridBpm=(intervals,ticks,reference=0)=>{
    // RhythmExtractor2013 exposes the actual beat-to-beat intervals. For a
    // steady song these are a better tempo ruler than averaging two separate
    // BPM estimators, especially for 1-BPM disagreements such as 135 vs 136.
    let secs=intervals.filter(v=>Number.isFinite(v)&&v>=60/208&&v<=60/40);
    if(secs.length<4)return 0;

    // Work in BPM space, fold occasional half/double beat intervals toward
    // the main RhythmExtractor estimate, then reject timing outliers with MAD.
    let bpms=secs.map(v=>60/v);
    if(reference>0){
      bpms=bpms.map(v=>{
        const candidates=[v,v*2,v/2].filter(x=>x>=40&&x<=208);
        return candidates.sort((a,b)=>Math.abs(a-reference)-Math.abs(b-reference))[0]||v;
      });
    }
    const med=median(bpms);
    const deviations=bpms.map(v=>Math.abs(v-med));
    const mad=median(deviations)||0.01;
    const kept=bpms.filter(v=>Math.abs(v-med)<=Math.max(0.85,3*mad));
    const intervalBpm=median(kept.length>=4?kept:bpms);

    // A line fitted through beat number vs. beat time averages small tracker
    // jitter over the whole song and gives another high-resolution grid tempo.
    let regressionBpm=0;
    if(ticks.length>=8){
      const clean=ticks.filter(Number.isFinite);
      const n=clean.length;
      if(n>=8){
        let sx=0,sy=0,sxx=0,sxy=0;
        for(let i=0;i<n;i++){sx+=i;sy+=clean[i];sxx+=i*i;sxy+=i*clean[i];}
        const den=n*sxx-sx*sx;
        const secondsPerBeat=den?((n*sxy-sx*sy)/den):0;
        if(secondsPerBeat>0)regressionBpm=60/secondsPerBeat;
        if(reference>0&&regressionBpm){
          const candidates=[regressionBpm,regressionBpm*2,regressionBpm/2].filter(x=>x>=40&&x<=208);
          regressionBpm=candidates.sort((a,b)=>Math.abs(a-reference)-Math.abs(b-reference))[0]||regressionBpm;
        }
      }
    }

    if(regressionBpm&&Math.abs(regressionBpm-intervalBpm)<=1.25){
      // Favor the median interval slightly; regression mainly removes jitter.
      return intervalBpm*.65+regressionBpm*.35;
    }
    return intervalBpm;
  };
  const essentiaBpm=async buffer=>{
    const essentia=await getEssentia();
    const prepared=await resample44100(buffer);
    const signal=monoFromBuffer(prepared);
    const vec=essentia.arrayToVector(signal);
    let multi=null;
    try{
      multi=essentia.RhythmExtractor2013(vec,208,'multifeature',40);
      const rhythmBpm=Number(multi&&multi.bpm)||0;
      const confidence=Number(multi&&multi.confidence)||0;
      const intervals=vectorArray(essentia,multi&&multi.bpmIntervals);
      const ticks=vectorArray(essentia,multi&&multi.ticks);
      const gridBpm=robustBeatGridBpm(intervals,ticks,rhythmBpm);

      // Percival stays as a sanity check for octave errors, but no longer gets
      // blindly averaged with RhythmExtractor when the estimates are merely
      // close. That averaging was able to turn a stable 135 grid into 136.
      let percival=0;
      try{
        const p=essentia.PercivalBpmEstimator(vec,1024,2048,128,128,210,50,44100);
        percival=Number(p&&p.bpm)||0;
      }catch(_){}

      let bpm=rhythmBpm||gridBpm||percival;
      if(gridBpm){
        const gridMatches=!rhythmBpm||Math.abs(gridBpm-rhythmBpm)<=2.25;
        const gridHalf=rhythmBpm&&Math.abs(gridBpm*2-rhythmBpm)<=3;
        const gridDouble=rhythmBpm&&Math.abs(gridBpm-rhythmBpm*2)<=3;
        if(gridMatches)bpm=gridBpm;
        else if(gridHalf||gridDouble)bpm=confidence>=0.05?rhythmBpm:gridBpm;
      }

      if(!bpm&&percival)bpm=percival;
      if(bpm&&percival){
        const half=Math.abs(bpm*2-percival)<=4;
        const dbl=Math.abs(bpm-percival*2)<=4;
        if((half||dbl)&&confidence<0.05&&!gridBpm)bpm=percival;
      }

      return {bpm,confidence,percival,gridBpm,rhythmBpm};
    }finally{
      if(multi){
        for(const k of ['ticks','estimates','bpmIntervals']){
          const v=multi[k];
          if(v&&typeof v.delete==='function')try{v.delete();}catch(_){}
        }
      }
      if(vec&&typeof vec.delete==='function')vec.delete();
    }
  };
  const mono=(b,maxSec=210)=>{const len=Math.min(b.length,Math.floor(b.sampleRate*maxSec)),o=new Float32Array(len),ch=Math.min(b.numberOfChannels,2);for(let c=0;c<ch;c++){const s=b.getChannelData(c);for(let i=0;i<len;i++)o[i]+=s[i]/ch;}return o;};
  const downsample=(s,sr,target=11025)=>{if(sr<=target*1.1)return{samples:s,sr};const ratio=sr/target,len=Math.floor(s.length/ratio),o=new Float32Array(len);for(let i=0;i<len;i++){const a=Math.floor(i*ratio),b=Math.min(s.length,Math.floor((i+1)*ratio));let sum=0;for(let j=a;j<b;j++)sum+=s[j];o[i]=sum/Math.max(1,b-a);}return{samples:o,sr:target};};
  const lowPass=(input,sr,cutoff)=>{const o=new Float32Array(input.length),x=Math.exp(-2*Math.PI*cutoff/sr);let y=0;for(let i=0;i<input.length;i++){y=(1-x)*input[i]+x*y;o[i]=y;}return o;};
  const onsetEnvelope=(samples,sr)=>{const lp220=lowPass(samples,sr,220),lp35=lowPass(samples,sr,35),hop=256,frame=512,count=Math.floor((samples.length-frame)/hop),bass=new Float64Array(count),full=new Float64Array(count),attack=new Float64Array(count);for(let f=0;f<count;f++){const st=f*hop;let b=0,a=0,d=0,prev=samples[st]||0;for(let i=0;i<frame;i++){const idx=st+i,x=samples[idx]||0,k=lp220[idx]-lp35[idx];b+=k*k;a+=x*x;d+=Math.abs(x-prev);prev=x;}bass[f]=Math.sqrt(b/frame);full[f]=Math.sqrt(a/frame);attack[f]=d/frame;}const flux=(env,w)=>{const o=new Float64Array(count);let avg=0;for(let i=1;i<count;i++){const v=Math.max(0,env[i]-env[i-1]);o[i]=v;avg+=v;}avg/=Math.max(1,count-1);const radius=12;let run=0;for(let i=0;i<count;i++){run+=o[i];if(i-radius-1>=0)run-=o[i-radius-1];const local=run/Math.min(i+1,radius+1);o[i]=Math.max(0,o[i]-Math.max(avg*.25,local*.58))*w;}return o;};const a=flux(bass,1.45),b=flux(full,.6),c=flux(attack,.42),onset=new Float64Array(count);for(let i=1;i<count-1;i++){const v=a[i]+b[i]+c[i];onset[i]=v*.62+(a[i-1]+b[i-1]+c[i-1])*.19+(a[i+1]+b[i+1]+c[i+1])*.19;}return{onset,bassOnset:a,fullOnset:b,attackOnset:c,fps:sr/hop};};
  const windowCandidates=(onset,fps,startFrame,frameCount)=>{const end=Math.min(onset.length,startFrame+frameCount);if(end-startFrame<fps*8)return[];const env=onset.subarray(startFrame,end),scores=[];let bestRaw=1e-12;for(let tempo=55;tempo<=210;tempo++){const lag=fps*60/tempo,l0=Math.floor(lag),frac=lag-l0;let s1=0,n1=0,n2=0;for(let i=l0+1;i<env.length;i++){const y=env[i-l0]*(1-frac)+env[i-l0-1]*frac,x=env[i];s1+=x*y;n1+=x*x;n2+=y*y;}let score=s1/(Math.sqrt(n1*n2)+1e-12);for(const [mult,w] of [[2,.28],[4,.12]]){const lm=Math.round(lag*mult);if(lm>=env.length)continue;let s=0,a=0,b=0;for(let i=lm;i<env.length;i++){const x=env[i],y=env[i-lm];s+=x*y;a+=x*x;b+=y*y;}score+=w*(s/(Math.sqrt(a*b)+1e-12));}scores.push({tempo,score});bestRaw=Math.max(bestRaw,score);}let mean=0;for(const v of env)mean+=v;mean/=env.length;let variance=0;for(const v of env)variance+=(v-mean)**2;const std=Math.sqrt(variance/env.length),threshold=mean+std*.65,peaks=[],minGap=Math.max(2,Math.round(fps*.11));let last=-minGap;for(let i=2;i<env.length-2;i++){if(env[i]>threshold&&env[i]>=env[i-1]&&env[i]>env[i+1]&&i-last>=minGap){peaks.push(i);last=i;}}const hist=new Float64Array(211);for(let i=0;i<peaks.length;i++)for(let j=i+1;j<Math.min(peaks.length,i+12);j++){const sec=(peaks[j]-peaks[i])/fps;if(sec<=0)continue;let t=60/sec;while(t<55)t*=2;while(t>210)t/=2;const ti=Math.round(t);if(ti>=55&&ti<=210)hist[ti]+=1/Math.sqrt(j-i);}let maxHist=1e-12;for(let t=55;t<=210;t++)maxHist=Math.max(maxHist,hist[t]);for(const item of scores){const t=item.tempo,h=(hist[t]+.55*(hist[t-1]||0)+.55*(hist[t+1]||0))/maxHist;item.score=.74*(item.score/bestRaw)+.26*h;}scores.sort((a,b)=>b.score-a.score);return scores.slice(0,8);};
  const tempoProfile=(source,sourceSR)=>{const ds=downsample(source,sourceSR),{onset,fps}=onsetEnvelope(ds.samples,ds.sr),duration=onset.length/fps,winSec=Math.min(34,Math.max(18,duration*.30)),winFrames=Math.floor(winSec*fps),centers=duration<38?[duration*.5]:[duration*.20,duration*.40,duration*.60,duration*.80],votes=[];centers.forEach((center,wi)=>{const start=Math.max(0,Math.min(onset.length-winFrames,Math.floor((center-winSec/2)*fps)));windowCandidates(onset,fps,start,winFrames).forEach((c,rank)=>votes.push({tempo:c.tempo,score:c.score*(1-rank*.045),window:wi}));});if(!votes.length)return{tempo:0,ranked:[]};const scored=[];for(let tempo=55;tempo<=210;tempo++){let score=0;const windows=new Set();for(const v of votes){const d=Math.min(Math.abs(tempo-v.tempo),Math.abs(tempo-v.tempo*2),Math.abs(tempo-v.tempo/2));if(d<=2.5){score+=v.score*(.35+.65*(1-d/2.5));windows.add(v.window);}}score*=1+Math.max(0,windows.size-1)*.18;if(tempo>=75&&tempo<=180)score*=1.025;scored.push({tempo,score,windows:windows.size});}scored.sort((a,b)=>b.score-a.score);return{tempo:scored[0].tempo,ranked:scored.slice(0,12)};};
  // Distributed tempo vote + low-frequency beat-grid verifier.
  // The general onset envelope can sometimes lock to hats, claps or syncopated
  // upper-frequency events one BPM away from the production grid. Kick/bass
  // transients are usually a better ruler for the underlying DAW tempo.
  const buildBassTempoContext=(source,sourceSR)=>{
    const ds=downsample(source,sourceSR,22050);
    const envs=onsetEnvelope(ds.samples,ds.sr);
    return {envs,fps:envs.fps};
  };
  const distributedTempoVote=(source,sourceSR,around,context=null)=>{
    const prepared=context||buildBassTempoContext(source,sourceSR),envs=prepared.envs,fps=prepared.fps;
    const env=envs.bassOnset&&envs.bassOnset.length?envs.bassOnset:envs.onset;
    const duration=env.length/fps;
    if(duration<12)return null;
    const winSec=Math.min(22,Math.max(12,duration*.18)),winFrames=Math.max(1,Math.floor(winSec*fps));
    const fractions=duration<35?[.25,.5,.75]:[.10,.30,.50,.70,.90];
    const center=Math.max(40,Math.min(208,Math.round(around||120))),scores=new Map(),perWindow=[];
    fractions.forEach((f,wi)=>{
      const mid=f*duration,start=Math.max(0,Math.min(env.length-winFrames,Math.floor((mid-winSec/2)*fps)));
      const ranked=windowCandidates(env,fps,start,winFrames).filter(x=>Math.abs(x.tempo-center)<=5);
      if(!ranked.length)return;
      perWindow.push(ranked[0].tempo);
      ranked.slice(0,4).forEach((c,rank)=>{
        const bpm=Math.round(c.tempo),weight=c.score*(1-rank*.16);
        scores.set(bpm,(scores.get(bpm)||0)+weight);
      });
    });
    const ranked=[...scores.entries()].map(([bpm,score])=>({bpm,score})).sort((a,b)=>b.score-a.score);
    return ranked.length?{bpm:ranked[0].bpm,ranked,perWindow}:null;
  };
  const bassGridPhaseTempo=(source,sourceSR,around,context=null)=>{
    const prepared=context||buildBassTempoContext(source,sourceSR),envs=prepared.envs,fps=prepared.fps;
    const onset=envs.bassOnset&&envs.bassOnset.length?envs.bassOnset:envs.onset;
    if(onset.length<fps*12)return null;
    let mean=0;for(const v of onset)mean+=v;mean/=onset.length;
    let variance=0;for(const v of onset)variance+=(v-mean)**2;
    const std=Math.sqrt(variance/onset.length),threshold=mean+std*.62,peaks=[];
    let last=-999,minGap=Math.max(2,Math.round(fps*.10));
    for(let i=2;i<onset.length-2;i++){
      if(onset[i]>threshold&&onset[i]>=onset[i-1]&&onset[i]>onset[i+1]&&i-last>=minGap){peaks.push({t:i/fps,w:onset[i]});last=i;}
    }
    if(peaks.length<18)return null;
    let maxW=1e-12;for(const p of peaks)maxW=Math.max(maxW,p.w);for(const p of peaks)p.w=Math.sqrt(p.w/maxW);
    const center=Math.max(40,Math.min(208,Math.round(around||120))),candidates=[];
    for(let bpm=Math.max(40,center-4);bpm<=Math.min(208,center+4);bpm++){
      const beat=60/bpm,sigma=Math.min(.032,beat*.075);let best=0;
      const phases=240;
      for(let k=0;k<phases;k++){
        const phase=beat*k/phases;let score=0,weight=0;
        for(const p of peaks){let d=((p.t-phase+beat/2)%beat+beat)%beat-beat/2;d=Math.abs(d);const q=Math.exp(-(d*d)/(2*sigma*sigma));score+=p.w*q;weight+=p.w;}
        score/=Math.max(weight,1e-12);if(score>best)best=score;
      }
      candidates.push({bpm,score:best});
    }
    candidates.sort((a,b)=>b.score-a.score);
    return{bpm:candidates[0].bpm,score:candidates[0].score,second:candidates[1]||null,ranked:candidates};
  };
  const resolveStudioTempo=async(source,sourceSR,essentiaResult)=>{
    const primary=Number(essentiaResult&&essentiaResult.bpm)||0,profile=tempoProfile(source,sourceSR);
    await tick();
    let chosen=primary||profile.tempo||0;
    if(profile.ranked.length){
      const folded=t=>{if(!primary)return t;const c=[t,t*2,t/2].filter(x=>x>=40&&x<=208);return c.sort((a,b)=>Math.abs(a-primary)-Math.abs(b-primary))[0]||t;};
      const near=profile.ranked.map(x=>({...x,folded:folded(x.tempo)})).filter(x=>!primary||Math.abs(x.folded-primary)<=4).sort((a,b)=>b.score-a.score);
      if(near.length){chosen=near[0].folded;if(primary&&Math.abs(chosen-Math.round(primary))>2.5)chosen=primary;}
    }

    // First ask several distributed low-frequency windows which integer tempo
    // repeats most consistently across the song.
    const bassContext=buildBassTempoContext(source,sourceSR);
    await tick();
    const vote=distributedTempoVote(source,sourceSR,chosen||primary||profile.tempo||120,bassContext);
    await tick();
    if(vote&&Math.abs(vote.bpm-Math.round(chosen||vote.bpm))<=3){
      const second=vote.ranked[1];
      if(!second||vote.ranked[0].score/Math.max(second.score,1e-9)>=1.06)chosen=vote.bpm;
    }

    // Final verification: compare nearby integer BPMs against the phase of
    // kick/bass transients across the full track. Only override when the low-
    // frequency grid wins decisively, so an ordinary true 136 BPM song is not
    // automatically shifted down to 135.
    const bassGrid=bassGridPhaseTempo(source,sourceSR,chosen||primary||120,bassContext);
    await tick();
    if(bassGrid&&bassGrid.second){
      const ratio=bassGrid.score/Math.max(bassGrid.second.score,1e-9);
      const distance=Math.abs(bassGrid.bpm-Math.round(chosen||bassGrid.bpm));
      if(distance<=4&&(ratio>=1.14||bassGrid.score>=.40))chosen=bassGrid.bpm;
    }
    return chosen||primary||profile.tempo;
  };
  const fft=(r,im)=>{const n=r.length;let j=0;for(let i=1;i<n;i++){let bit=n>>1;for(;j&bit;bit>>=1)j^=bit;j^=bit;if(i<j){[r[i],r[j]]=[r[j],r[i]];[im[i],im[j]]=[im[j],im[i]];}}for(let len=2;len<=n;len<<=1){const ang=-2*Math.PI/len,wc=Math.cos(ang),ws=Math.sin(ang);for(let i=0;i<n;i+=len){let cr=1,ci=0;for(let k=0;k<len/2;k++){const ur=r[i+k],ui=im[i+k],vr=r[i+k+len/2]*cr-im[i+k+len/2]*ci,vi=r[i+k+len/2]*ci+im[i+k+len/2]*cr;r[i+k]=ur+vr;im[i+k]=ui+vi;r[i+k+len/2]=ur-vr;im[i+k+len/2]=ui-vi;const nr=cr*wc-ci*ws;ci=cr*ws+ci*wc;cr=nr;}}}};
  const legacyKey=(s,sr)=>{const N=4096,ch=new Float64Array(12),frames=Math.min(42,Math.max(14,Math.floor(s.length/(sr*2.6)))),startBase=Math.min(Math.max(0,s.length-N),Math.floor(sr*2)),endBase=Math.max(startBase,s.length-N);for(let f=0;f<frames;f++){const t=frames===1?0:f/(frames-1),st=Math.max(0,Math.floor(startBase+(endBase-startBase)*t)),r=new Float64Array(N),im=new Float64Array(N);for(let i=0;i<N;i++){const w=.5-.5*Math.cos(2*Math.PI*i/(N-1));r[i]=(s[st+i]||0)*w;}fft(r,im);const minBin=Math.ceil(55*N/sr),maxBin=Math.min(N/2-1,Math.floor(1760*N/sr));for(let bin=minBin;bin<=maxBin;bin++){const freq=bin*sr/N,m=69+12*Math.log2(freq/440),near=Math.round(m);if(Math.abs(m-near)>.42)continue;const pc=((near%12)+12)%12,mag=Math.hypot(r[bin],im[bin]),wt=freq>880?.50:(freq>440?.76:1);ch[pc]+=mag*wt;}}const sum=ch.reduce((a,b)=>a+b,0)||1;for(let i=0;i<12;i++)ch[i]/=sum;const maj=[6.35,2.23,3.48,2.33,4.38,4.09,2.52,5.19,2.39,3.66,2.29,2.88],min=[6.33,2.68,3.52,5.38,2.60,3.53,2.54,4.75,3.98,2.69,3.34,3.17],names=['C','C♯','D','D♯','E','F','F♯','G','G♯','A','A♯','B'];const corr=(p,t)=>{let dot=0,a=0,b=0;for(let pc=0;pc<12;pc++){const x=p[(pc-t+12)%12];dot+=ch[pc]*x;a+=ch[pc]*ch[pc];b+=x*x;}return dot/(Math.sqrt(a*b)+1e-12);};let best={score:-Infinity,tonic:0,mode:'major'};for(let t=0;t<12;t++){const a=corr(maj,t),b=corr(min,t);if(a>best.score)best={score:a,tonic:t,mode:'major'};if(b>best.score)best={score:b,tonic:t,mode:'minor'};}return{tonic:names[best.tonic],mode:best.mode};};
  // Tonal analysis v2: use Essentia's HPCP-based KeyExtractor with the
  // Sha'ath key profile. Sha'ath was designed for popular/electronic music
  // and is much closer to the KeyFinder approach than the old snapshot FFT.
  const normalizeTonic=name=>{
    const map={'C#':'C♯','Db':'D♭','D#':'D♯','Eb':'E♭','F#':'F♯','Gb':'G♭','G#':'G♯','Ab':'A♭','A#':'A♯','Bb':'B♭'};
    return map[name]||name;
  };
  const KEY_NAMES=['C','C♯','D','D♯','E','F','F♯','G','G♯','A','A♯','B'];
  const keyIndex=name=>{
    const map={'C':0,'C♯':1,'D♭':1,'D':2,'D♯':3,'E♭':3,'E':4,'F':5,'F♯':6,'G♭':6,'G':7,'G♯':8,'A♭':8,'A':9,'A♯':10,'B♭':10,'B':11};
    return map[name];
  };
  const relativePartner=(tonic,mode)=>{
    const i=keyIndex(tonic); if(i==null)return null;
    return mode==='major'
      ? {tonic:KEY_NAMES[(i+9)%12],mode:'minor'}
      : {tonic:KEY_NAMES[(i+3)%12],mode:'major'};
  };
  const extractKeyPass=(essentia,samples,sr,profile='shaath',frameSize=8192,hopSize=4096)=>{
    const vec=essentia.arrayToVector(samples);
    try{
      const result=essentia.KeyExtractor(
        vec,
        true,
        frameSize,
        hopSize,
        36,
        3500,
        100,
        40,
        0.2,
        profile,
        sr,
        0.0001,
        440,
        'cosine',
        'hann'
      );
      const tonic=normalizeTonic(String(result&&result.key||'').trim());
      const mode=String(result&&result.scale||'').toLowerCase();
      const strength=Math.max(0,Number(result&&result.strength)||0);
      if(!tonic||!['major','minor'].includes(mode))return null;
      return {tonic,mode,strength,profile};
    }finally{
      if(vec&&typeof vec.delete==='function')vec.delete();
    }
  };
  const sliceRegion=(samples,sr,centerSec,lengthSec)=>{
    const n=Math.min(samples.length,Math.max(1,Math.floor(lengthSec*sr)));
    const center=Math.floor(centerSec*sr);
    const start=Math.max(0,Math.min(samples.length-n,center-Math.floor(n/2)));
    return samples.subarray(start,start+n);
  };
  const essentiaKey=async(samples,sr)=>{
    const essentia=await getEssentia();
    const duration=samples.length/sr;
    if(duration<6)throw new Error('No stable tonal center found.');

    // Analyze several harmonically independent song regions instead of relying
    // on one global pass. This reduces errors from drum intros, breakdowns,
    // key changes, sparse outros, and relative-major/minor ambiguity.
    const regionLength=Math.min(30,Math.max(14,duration*.16));
    const fractions=duration<35?[.28,.50,.72]:[.12,.30,.50,.70,.88];
    const passes=[];
    for(let i=0;i<fractions.length;i++){
      const region=sliceRegion(samples,sr,duration*fractions[i],regionLength);
      if(region.length<sr*6)continue;
      const r=extractKeyPass(essentia,region,sr,'shaath',8192,4096);
      if(r)passes.push({...r,region:i});
      // Give the browser a frame between heavy DSP passes so the UI stays responsive.
      await tick();
    }
    if(!passes.length)throw new Error('No stable tonal center found.');

    // Build a compact broad-coverage sample and run a second profile as a
    // sanity check. Sha'ath remains primary; Temperley only nudges close calls.
    const broadSec=Math.min(75,Math.max(30,duration*.36));
    const blockSec=broadSec/3;
    const broad=new Float32Array(Math.floor(broadSec*sr));
    const centers=[duration*.20,duration*.50,duration*.80];
    for(let i=0;i<3;i++){
      const block=sliceRegion(samples,sr,centers[i],blockSec);
      broad.set(block.subarray(0,Math.min(block.length,Math.floor(blockSec*sr))),Math.floor(i*blockSec*sr));
    }
    const globalShaath=extractKeyPass(essentia,broad,sr,'shaath',8192,4096);
    const globalTemperley=extractKeyPass(essentia,broad,sr,'temperley',8192,4096);
    if(globalShaath)passes.push({...globalShaath,region:'global',global:true});

    // Confidence-weighted consensus. Regional agreement matters more than a
    // single high-strength frame, while the broad/global pass breaks ties.
    const scoreMap=new Map();
    const addScore=(r,weight=1)=>{
      const key=`${r.tonic}|${r.mode}`;
      const strength=Math.max(.08,Math.min(1.25,r.strength||0));
      const contribution=weight*(.55+Math.sqrt(strength));
      const entry=scoreMap.get(key)||{tonic:r.tonic,mode:r.mode,score:0,votes:0,strengthSum:0};
      entry.score+=contribution;
      entry.votes+=1;
      entry.strengthSum+=strength;
      scoreMap.set(key,entry);
    };
    passes.forEach(r=>addScore(r,r.global?1.15:1));

    // Secondary profile is deliberately low-weight: it confirms close calls
    // but cannot override a clear Sha'ath regional consensus on its own.
    if(globalTemperley)addScore(globalTemperley,.42);

    const ranked=[...scoreMap.values()].sort((a,b)=>b.score-a.score);
    if(!ranked.length)throw new Error('No stable tonal center found.');
    let best=ranked[0],second=ranked[1]||null;

    // Explicitly examine a relative major/minor tie. When the top two are a
    // relative pair and almost tied, prefer the one with more independent
    // regional votes; otherwise retain the stronger weighted consensus.
    if(second){
      const rel=relativePartner(best.tonic,best.mode);
      const isRelative=rel&&keyIndex(rel.tonic)===keyIndex(second.tonic)&&rel.mode===second.mode;
      const close=second.score/best.score>.92;
      if(isRelative&&close&&second.votes>best.votes)best=second;
    }

    const totalScore=ranked.reduce((a,b)=>a+b.score,0)||1;
    const confidence=Math.min(1,best.score/totalScore + Math.min(.28,(best.votes-1)*.07));
    return {
      tonic:best.tonic,
      mode:best.mode,
      strength:best.strengthSum/Math.max(1,best.votes),
      confidence,
      votes:best.votes,
      engine:'essentia-shaath-consensus'
    };
  };

  // Circle-of-fifths verifier: profile-based key estimators can confuse keys
  // a perfect fifth apart when the dominant is heavily emphasized. Build an
  // independent pitch-class energy map and compare the actual scale membership
  // before accepting a close fifth-related result.
  const pitchClassEvidence=(samples,sr)=>{
    const N=8192,frames=Math.min(64,Math.max(24,Math.floor(samples.length/(sr*2.2))));
    const chroma=new Float64Array(12);
    const startBase=Math.min(Math.max(0,samples.length-N),Math.floor(sr*3));
    const endBase=Math.max(startBase,samples.length-N);
    for(let f=0;f<frames;f++){
      const t=frames===1?0:f/(frames-1);
      const st=Math.max(0,Math.floor(startBase+(endBase-startBase)*t));
      const r=new Float64Array(N),im=new Float64Array(N);
      for(let i=0;i<N;i++){
        const w=.5-.5*Math.cos(2*Math.PI*i/(N-1));
        r[i]=(samples[st+i]||0)*w;
      }
      fft(r,im);
      const minBin=Math.ceil(48*N/sr),maxBin=Math.min(N/2-1,Math.floor(2200*N/sr));
      for(let bin=minBin;bin<=maxBin;bin++){
        const freq=bin*sr/N;
        const midi=69+12*Math.log2(freq/440);
        const nearest=Math.round(midi);
        if(Math.abs(midi-nearest)>.34)continue;
        const pc=((nearest%12)+12)%12;
        const mag=Math.hypot(r[bin],im[bin]);
        // Keep low and low-mid harmonic information influential without
        // allowing sub/bass dominance alone to decide the key.
        const weight=freq<220?1.18:(freq<520?1:(freq<1100?.74:.52));
        chroma[pc]+=mag*weight;
      }
    }
    let sum=0;for(const v of chroma)sum+=v;
    if(sum>0)for(let i=0;i<12;i++)chroma[i]/=sum;
    return chroma;
  };
  const scaleIntervals=mode=>mode==='minor'?[0,2,3,5,7,8,10]:[0,2,4,5,7,9,11];
  const scaleFit=(chroma,tonic,mode)=>{
    const t=keyIndex(tonic); if(t==null)return 0;
    let inside=0; for(const n of scaleIntervals(mode))inside+=chroma[(t+n)%12]||0;
    return inside;
  };
  const fifthNeighbor=(tonic,dir)=>{
    const i=keyIndex(tonic); if(i==null)return null;
    return KEY_NAMES[(i+(dir>0?7:5))%12];
  };
  const uniqueScaleTone=(tonicA,tonicB,mode)=>{
    const a=scaleIntervals(mode).map(n=>(keyIndex(tonicA)+n)%12);
    const b=new Set(scaleIntervals(mode).map(n=>(keyIndex(tonicB)+n)%12));
    return a.find(x=>!b.has(x));
  };
  const verifyFifthAmbiguity=(result,samples,sr)=>{
    if(!result||!['major','minor'].includes(result.mode))return result;
    const chroma=pitchClassEvidence(samples,sr);
    const currentFit=scaleFit(chroma,result.tonic,result.mode);
    let best={tonic:result.tonic,fit:currentFit};
    for(const dir of [-1,1]){
      const tonic=fifthNeighbor(result.tonic,dir); if(!tonic)continue;
      const fit=scaleFit(chroma,tonic,result.mode);
      const candUnique=uniqueScaleTone(tonic,result.tonic,result.mode);
      const curUnique=uniqueScaleTone(result.tonic,tonic,result.mode);
      const candEvidence=candUnique==null?0:(chroma[candUnique]||0);
      const curEvidence=curUnique==null?0:(chroma[curUnique]||0);
      // Require both materially better scale coverage and support from the
      // note that distinguishes the two neighboring keys. This prevents a
      // strong dominant/bass note from flipping the answer by itself.
      const clearlyBetter=fit>=currentFit+.055 && fit>=currentFit*1.075;
      const uniqueSupport=candEvidence>=curEvidence*1.28 && candEvidence-curEvidence>=.012;
      if(clearlyBetter&&uniqueSupport&&fit>best.fit)best={tonic,fit};
    }
    if(best.tonic!==result.tonic){
      return {...result,tonic:best.tonic,verifiedFrom:result.tonic,engine:(result.engine||'essentia')+'+scale-verifier'};
    }
    return result;
  };

  const detectKey=async(samples,sr)=>{
    try{
      const primary=await essentiaKey(samples,sr);
      return verifyFifthAmbiguity(primary,samples,sr);
    }catch(err){
      console.warn('Advanced key analysis unavailable; using local fallback.',err);
      return legacyKey(samples,sr);
    }
  };

  const camelot=(tonic,mode)=>{const maj={'B':'1B','F♯':'2B','D♭':'3B','A♭':'4B','E♭':'5B','B♭':'6B','F':'7B','C':'8B','G':'9B','D':'10B','A':'11B','E':'12B'},min={'G♯':'1A','E♭':'2A','B♭':'3A','F':'4A','C':'5A','G':'6A','D':'7A','A':'8A','E':'9A','B':'10A','F♯':'11A','D♭':'12A'},enh={'C♯':'D♭','D♯':'E♭','A♯':'B♭'},k=enh[tonic]||tonic;return mode==='minor'?(min[k]||''):(maj[k]||'');};
  const relativeKey=(tonic,mode)=>{
    const minorToMajor={
      'C':'E♭ major','C♯':'E major','D♭':'E major','D':'F major','D♯':'F♯ major','E♭':'F♯ major',
      'E':'G major','F':'A♭ major','F♯':'A major','G♭':'A major','G':'B♭ major','G♯':'B major','A♭':'B major',
      'A':'C major','A♯':'C♯ major','B♭':'D♭ major','B':'D major'
    };
    const majorToMinor={
      'C':'A minor','C♯':'A♯ minor','D♭':'B♭ minor','D':'B minor','D♯':'C minor','E♭':'C minor',
      'E':'C♯ minor','F':'D minor','F♯':'D♯ minor','G♭':'E♭ minor','G':'E minor','A♭':'F minor',
      'A':'F♯ minor','A♯':'G minor','B♭':'G minor','B':'G♯ minor'
    };
    return mode==='minor' ? (minorToMajor[tonic] || '') : (majorToMinor[tonic] || '');
  };
  const enharmonicSpelling=(tonic,mode)=>{
    const map={
      'C♯':'D♭','D♭':'C♯',
      'D♯':'E♭','E♭':'D♯',
      'F♯':'G♭','G♭':'F♯',
      'G♯':'A♭','A♭':'G♯',
      'A♯':'B♭','B♭':'A♯'
    };
    const alt=map[tonic];
    return alt ? `${alt} ${mode}` : '';
  };

  const formatTempo=value=>{
    const rounded=Math.round(Number(value)*100)/100;
    if(!Number.isFinite(rounded))return '—';
    return Number.isInteger(rounded)?String(rounded):String(rounded.toFixed(2).replace(/0+$/,'').replace(/\.$/,''));
  };
  const setTempo=t=>{
    const value=Number(t);
    currentTempo=Math.max(1,Math.round(value*100)/100);
    bpmOut.textContent=formatTempo(currentTempo);
    halfOut.textContent=formatTempo(currentTempo/2);
    doubleOut.textContent=formatTempo(currentTempo*2);
  };
  // The finder presents the detected song tempo as a whole-number BPM.
  // Half-/double-time values must be calculated from that exact displayed BPM,
  // not from a hidden fractional estimator value. Example: 135 -> 67.5 / 270.
  const setDetectedTempo=t=>{
    const value=Number(t);
    if(!Number.isFinite(value)||value<=0){setTempo(1);return;}
    setTempo(Math.round(value));
  };
  const analyze=async file=>{if(!file)return;errorBox.hidden=true;setState('progress');detail.textContent='Decoding audio…';await tick();try{const b=await decode(file);if(!b||b.duration<6)throw new Error('Please choose a song that is at least 6 seconds long.');const m=mono(b);detail.textContent='Tracking the beat with Essentia…';await tick();const tempoResult=await essentiaBpm(b);detail.textContent='Verifying tempo across the song…';await tick();const tempo=await resolveStudioTempo(m,b.sampleRate,tempoResult);detail.textContent='Detecting musical key…';await tick();const musicalKey=await detectKey(m,b.sampleRate);fileName.textContent=file.name;setDetectedTempo(tempo||0);if(keyNoteOut&&keyModeOut){keyNoteOut.textContent=musicalKey.tonic;keyModeOut.textContent=musicalKey.mode;}else{keyOut.textContent=`${musicalKey.tonic} ${musicalKey.mode}`;}const cam=camelot(musicalKey.tonic,musicalKey.mode);camelotOut.textContent=cam?`Camelot ${cam}`:'Key estimate';const rel=relativeKey(musicalKey.tonic,musicalKey.mode);if(rel){relativeKeyOut.textContent=rel;relativeLabel.textContent=musicalKey.mode==='minor'?'Relative Major':'Relative Minor';relativeKeyWrap.hidden=false;}else{relativeKeyWrap.hidden=true;}const enh=enharmonicSpelling(musicalKey.tonic,musicalKey.mode);const primarySpelling=`${musicalKey.tonic} ${musicalKey.mode.charAt(0).toUpperCase()+musicalKey.mode.slice(1)}`;if(keySpellingOut&&keySpellingWrap){keySpellingOut.textContent=enh?`${primarySpelling} / ${enh.replace(/\b(major|minor)\b/g,m=>m.charAt(0).toUpperCase()+m.slice(1))}`:primarySpelling;keySpellingWrap.hidden=false;}if(enharmonicKeyOut){enharmonicKeyOut.hidden=true;}setState('results');requestAnimationFrame(()=>{if(keyDial){keyDial.classList.remove('is-key-revealed');void keyDial.offsetWidth;keyDial.classList.add('is-key-revealed');}if(tempoStage){tempoStage.classList.remove('is-bpm-revealed');void tempoStage.offsetWidth;tempoStage.classList.add('is-bpm-revealed');}});}catch(e){showError(e&&e.message?e.message:'We could not analyze that file. Try a different audio format.');}};
  dropzone.addEventListener('click',()=>input.click());dropzone.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();input.click();}});input.addEventListener('change',()=>analyze(input.files&&input.files[0]));
  ['dragenter','dragover'].forEach(t=>dropzone.addEventListener(t,e=>{e.preventDefault();dropzone.classList.add('is-dragging');}));['dragleave','drop'].forEach(t=>dropzone.addEventListener(t,e=>{e.preventDefault();dropzone.classList.remove('is-dragging');}));dropzone.addEventListener('drop',e=>{const f=e.dataTransfer&&e.dataTransfer.files&&e.dataTransfer.files[0];if(f)analyze(f);});
  halfBtn.addEventListener('click',()=>setTempo(currentTempo/2));doubleBtn.addEventListener('click',()=>setTempo(currentTempo*2));
  again.addEventListener('click',()=>{input.value='';setState('drop');dropzone.focus();});setState('drop');
})();